import React from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'react-router5';

import { getCurrentRoute } from './selectors';

export const useCopyCurrentUrlToClipboard = () => {
  const router = useRouter();

  const currentRoute = useSelector(getCurrentRoute);
  return React.useCallback(async () => {
    if (!currentRoute) {
      return;
    }

    const url = new URL(router.buildUrl(currentRoute.name, currentRoute.params), location.origin);

    await navigator.clipboard.writeText(url.href);
  }, [currentRoute, router]);
};
